function initHero() {
  const hero = document.querySelector('.section-hero');
  if(!hero) return;

  const heroSlider = new Swiper('.hero-slider', {
    effect: "fade",
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: true,
    navigation: {
      prevEl: '.hero-slider__button.prev',
      nextEl: '.hero-slider__button.next'
    },
    pagination: {
      el: ".hero-slider__pagination",
      type: "fraction",
    },
  });
}

window.addEventListener('load', initHero);